<template>
  <div class='container'>
    <el-dialog
			title="当前账套存在以下问题"
			:visible.sync="isShow"
			:close-on-click-modal="false"
			width='680px' class='default-dialog'>
      <div class="btn-wrap">
        <span size="small" @click="$refs.HistoryProblems.handleOpen()" >历史问题</span>
      </div>
      <PublicTable :table="tableData" ref="PublicTable" />
			<div slot="footer" align="center" class="dialog-footer" v-if="!loading">
        <el-button size="small" class='minButton' @click="handleConfirm" :disabled="isDisabled">知道了</el-button>
      </div>
		</el-dialog>

    <!-- 历史问题查看 -->
    <HistoryExistProblems ref="HistoryProblems" />
  </div>
</template>

<script>
import HistoryExistProblems from './HistoryExistProblems'
import PublicTable from "@/components/publicTable"
import { findRejects } from '@/api'
export default {
  components:{HistoryExistProblems,PublicTable},
  props:{},
  created() {},
  data() {
    return {
      isShow: false,
      isDisabled: false,
      loading: false,
      tableData: {
        border: true, // 是否带有纵向边框
        stripe: true, // 是否带有斑马纹
        loading: false, // 是否显示加载动画
        config: [
          { label: "账期", value: "yearPeriods", show: "normal",width: 60 },
          { label: "驳回原因", value: "problem", show: "normal" },
          { label: "管理会计", value: "name", show: "normal" ,width: 60},
          { label: "时间", value: "examineDate", show: "template",type:'date',dateType:'yyyy-MM-dd',width: 60 },
        ],
        data: [],
        page: {
          pageNo: 1,
          pageSize: 10,
          count: 10
        },
        center: {
          textAlign: "left",
          padding: "6px 0"
        },
      }
    }
  },
  methods:{
    handleOpen() {
      this.isShow = true
      this.getRejectList()
    },
    handleConfirm() {
      this.isShow = false
    },
    // 获取列表数据
    async getRejectList() {
      try {
        this.tableData.loading = true
        const { data } = await findRejects({
          cid: JSON.parse(sessionStorage.getItem("cid")),
          isHistory: false,
        })
        if(data.code == 1) {
          this.tableData.data = data.data
          this.tableData.loading = false
        }
      } catch (error) {
        this.tableData.loading = false
      }
    }
  },
}
</script>

<style lang='less' scoped>
.container {
  .btn-wrap {
    text-align: right;
    margin-bottom: 10px;
    span {
      color: #268AFF;
      cursor: pointer;
      &:hover {
        filter: brightness(90%);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/ExistingProblems.vue